import * as moment from "moment";
import * as _ from "lodash";

function setDataFinancial(financial: any, lifestyle: any) {
  if (!financial) {
    throw new Error("financial has not been created");
  }
  const myFinancial = {
    bigInvestmentPlan: {
      financeSpecialProject: 0,
      financeCapital: 0,
      currentSavings: 0,
      startingFinancing: 2,
      investmentRates: 0.04,
      inflationRates: 0.02
    }
  };
  _.forEach(financial, financialItem => {
    const saving = {
      otherSavings: 0,
      timeSavings: 0,
      monthlyIncome: 0,
      investmentRates: 0.04,
      inflationRates: 0.02
    };
    const retirement = {
      investmentRates: 0.04,
      inflationRates: 0.02,
      startSavingIn: 2
    };
    const incomeProtection = {
      monthlyLoanCost: 0,
      endOfMonthlyLoan: 0,
      otherInstallmentCommitment: 0,
      endOfOtherInstallmentCommitment: 0,
      inflationRates: 0.02
    };
    const financialPart = {};
    _.forEach(financialItem.questionRaws, question => {
      financialPart[question.key] = question.value;
      if (question.order <= 3) {
        myFinancial['savings'] = { ...financialPart, ...saving };
      } else {
        myFinancial['retirement'] = { ...financialPart, ...retirement };
        myFinancial['incomeProtection'] = { ...financialPart, ...incomeProtection }
      }
    });
  });

  _.forEach(lifestyle, lifestyleItem => {
    const lifestylePart = {};
    const data = {
      healthPreventionAnalysis: -50
    }
    _.forEach(lifestyleItem.questionRaws, question => {
      lifestylePart[question.key] = question.value;
    });
    myFinancial['health'] = { ...lifestylePart, ...data }
  });
  return myFinancial
}

function setDataProfile(save, dataProfile) {
  const profile: any = {};
  const { userProfile } = dataProfile;
  _.forEach(save, saveItem => {
    profile[saveItem.key] = saveItem.value;
  });
  profile["dateOfBirth"] = moment(dataProfile.dob).format("DD/MM/YYYY");
  profile["email"] = userProfile.email;
  profile["gender"] = Number(userProfile.gender) === 0 ? "FEMALE" : "MALE";
  profile["kids"] = userProfile.kids;
  profile["marital"] = Number(userProfile.marital) === 0 ? 1 : 0;
  //profile["CitizenType"] = save.CitizenType !== "Foreigner" ? "Singaporean" : "";
  profile["smoked"] = Number(userProfile.smoked);
  profile["countrycode"] = userProfile.countrycode;
  return profile;
}

function onLifestyleError(data) {
  const isMyHeight = _.some(_.filter(data, item => item.key === "myHeight"), ['value', 120]);
  const isMyWeight = _.some(_.filter(data, item => item.key === "myWeight"), ['value', 30]);
  const isData = _.some(_.filter(data, item => item.key !== "myHeight" && item.key !== 'myWeight'), ['value', 50]);
  const newArray = _.filter([isMyHeight, isMyWeight, isData], item => item === true)
  return newArray.length ===0
}

function onFinancialError(data,age) {
  const isYearNotNeedSupport = _.some(_.filter(data, item => item.key === "yearNotNeedSupport"), ['value', age]);
  const isYearRetirement = _.some(_.filter(data, item => item.key === "yearRetirement"), ['value', age]);
  const isData = _.some(_.filter(data, item => item.key !== "yearNotNeedSupport" && item.key !== 'yearRetirement'), ['value', 0]);
  const newArray = _.filter([isYearNotNeedSupport, isYearRetirement, isData], item => item === true)
  return newArray.length === 0
}

export {
  setDataFinancial,
  setDataProfile,
  onLifestyleError,
  onFinancialError
}



// WEBPACK FOOTER //
// ./src/app/core/selectors.ts